<template>
    <fade-in-out>
        <forgot-password-small
            v-if="showForgotPassword"
            :default-email="defaultEmail"
            @close="showForgotPassword = false"
        ></forgot-password-small>


        <login-provider :default-email="defaultEmail" :successfulEvent="successfulEvent" v-else>
            <div class="relative max-w-lg w-full mx-auto pb-8 block" slot-scope="{ email, password, rememberMe, login, posting, error, setError }">
                <span class="block text-sm text-center">
                    {{ _('login_form.sso_appls_headline') }}
                </span>

                <div class="grid gap-x-2 lg:gap-x-4 mt-2"
                    v-bind:class="{'grid-cols-2': isSv, 'grid-cols-1': !isSv}"
                >
                    <div class="">

                        <apple-button
                            @error="setError"
                            :prevent-registration="true"
                        >
                            <div slot-scope="{ startLoginProcess, working }">
                                <button
                                    @click.prevent="startLoginProcess"
                                    class="h-8 btn-hover-only w-full flex items-center justify-center bg-black rounded text-sm"
                                >
                                    <div class="flex items-center">
                                        <svg-icon v-show="working" url="fas/spinner" class="fas fa-spin w-4 h-4 cursor-pointer flex items-center text-white"></svg-icon>

                                        <svg-icon v-show="!working" url="fab/apple" class="fab w-4 h-4 cursor-pointer text-white"></svg-icon>
                                    </div>
                                    <span class="ml-2 text-white">
                                        {{ _('register_form_v3.sso_apps.apple_button') }}
                                    </span>
                                </button>
                            </div>
                        </apple-button>

                    </div>

                    <div v-if="isSv">

                        <freja-button
                            @error="setError"
                            :prevent-registration="true"
                        >
                            <div slot-scope="{ startLoginProcess, working }">
                                <button
                                    @click.prevent="startLoginProcess"
                                    class="h-8 btn-hover-only w-full flex items-center justify-center bg-freja rounded text-sm"
                                >
                                    <div class="flex items-center">
                                        <span v-show="working" v-cloak>
                                            <svg-icon url="fas/spinner" class="fas fa-spin w-4 h-4 cursor-pointer flex items-center text-white"></svg-icon>
                                        </span>

                                        <span v-if="!working" v-cloak>
                                            <img src="https://cdn.refunder.se/site/resources/img/logos/freja-white.svg" class="h-3" />
                                        </span>
                                    </div>
                                </button>
                            </div>
                        </freja-button>

                    </div>
                </div>

                <div class="md:my-8 my-4 relative">
                    <div class="absolute inset-0 flex items-center w-full">
                        <div class="w-full border-t border-gray-400"></div>
                    </div>
                    <div class="relative flex justify-center text-sm">
                        <span class="px-2 bg-white">
                            {{ _('Login_page_or') }}
                        </span>
                    </div>
                </div>

                <form
                    :action="getPath('LOGIN_POST_URL')"
                    v-on:submit.prevent="login"
                    method="post"
                >
                    <p v-if="error" class="text-red-500 text-center mb-4 md:mb-8">
                        {{ error }}
                    </p>

                    <yellow-icon-text-input
                        :label="_('Dialog_login_register_input_email')"
                        :value="email.props.value"
                        @input="email.events.input"
                        type="email"
                        name="login_email"
                        icon="user"
                        :placeholder="_('login.form.email.placeholder')"
                        class="mb-4"
                    ></yellow-icon-text-input>

                    <yellow-icon-password-input
                        :label="_('Dialog_login_input_password')"
                        :value="password.props.value"
                        @input="password.events.input"
                        type="password"
                        name="login_password"
                        icon="lock"
                        :placeholder="_('login.form.password.placeholder')"
                        class="mb-4"
                ></yellow-icon-password-input>

                    <div class="flex justify-between items-center mb-8">

                        <div class="flex items-center">
                            <input
                                v-bind="rememberMe.props"
                                v-on="rememberMe.events"
                                type="checkbox"
                                class="focus:ring-primary-500 h-4 w-4 text-primary-700 border-gray-300"
                                name="remember_me"
                                id="remember-login"
                                checked="checked"
                            />

                            <label for="remember-login" class="pl-2">
                                {{ _('Dialog_login_input_remember_me') }}
                            </label>
                        </div>

                        <a @click.prevent="showForgotPassword = true" class="text-primary-700 italic cursor-pointer">
                            {{ _('Dialog_login_forgot_password_link') }}
                        </a>

                    </div>

                    <button
                        class="btn btn-primary w-full block mb-8"
                        type="submit"
                    >
                        <svg-icon v-if="posting" url="far/spinner" class="fa-spin w-5 h-5 mx-auto"></svg-icon>
                        <span v-else>
                            {{ _('Dialog_login_submit') }}
                        </span>
                    </button>

                    <p class="text-center font-bold" v-if="linkToRegister">
                        {{ _('Login_no_account') }}
                        <a
                            :href="getPath('user.register')"
                            class="text-primary-700"
                        >
                            {{ _('Join_free') }} »
                        </a>
                    </p>

                </form>
            </div>
        </login-provider>
    </fade-in-out>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        props: {
            defaultEmail: {
                type: String,
                required: false,
            },
            linkToRegister: {
                required: false,
                type: Boolean,
                default: true,
            },
            facebook: {
                required: false,
                type: Boolean,
                default: true,
            },
            apple: {
                required: false,
                type: Boolean,
                default: true,
            },
            successfulEvent: {
                required: false,
                type: String
            },
        },

        data() {
            return {
                showForgotPassword: false,
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath', 'isSv']),
        },

        methods: {
            ...mapMutations('modal', ['showModal'])
        }
    }

</script>
